"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledText = exports.StyledSpinner = exports.StyledInput = exports.StyledForm = exports.StyledButtonText = exports.StepsOverviewWrapper = exports.ClickBlocker = exports.ChecklistOverviewWrapper = exports.ButtonWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChecklistOverviewWrapper = exports.ChecklistOverviewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ChecklistOverviewWrapper",
  componentId: "sc-e47npl-0"
})(["display:flex;height:100%;flex-direction:column;justify-content:space-between;"]);
var StyledForm = exports.StyledForm = _styledComponents["default"].form.withConfig({
  displayName: "styles__StyledForm",
  componentId: "sc-e47npl-1"
})(["z-index:10;position:relative;display:flex;flex-direction:", ";padding:15px;"], function (_ref) {
  var isDesktop = _ref.isDesktop;
  return isDesktop ? 'row' : 'column';
});
var StepsOverviewWrapper = exports.StepsOverviewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StepsOverviewWrapper",
  componentId: "sc-e47npl-2"
})(["overflow-y:auto;flex:1;"]);
var StyledInput = exports.StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "styles__StyledInput",
  componentId: "sc-e47npl-3"
})(["padding:15px;height:50px;font-size:14px;margin-top:10px;border:1px solid ", ";border-radius:3px;outline:none;", "::placeholder,::-webkit-input-placeholder{color:", ";}:-ms-input-placeholder{color:", ";}&:focus{border:1px solid ", ";-webkit-box-shadow:0px 0px 3px 1px ", ";box-shadow:0px 0px 3px 1px ", ";}"], _palette.commonPalette.borderGrey, function (p) {
  return p.isDesktop && "\n    flex: 1;\n  ";
}, _palette.commonPalette.txLightGrey, _palette.commonPalette.txLightGrey, _palette.commonPalette.sgGreen, _palette.commonPalette.sgGreen, _palette.commonPalette.sgGreen);
var ButtonWrapper = exports.ButtonWrapper = _styledComponents["default"].button.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-e47npl-4"
})(["background-color:", ";border-radius:3px;border:none;margin-top:10px;text-align:center;outline:none;height:50px;cursor:", ";z-index:999;pointer-events:all;display:flex;justify-content:center;align-items:center;", ""], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? _palette.commonPalette.ghostlyGreen : _palette.commonPalette.sgGreen;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? '' : 'pointer';
}, function (p) {
  return p.isDesktop && "\n    flex: 1;\n  ";
});
var StyledButtonText = exports.StyledButtonText = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledButtonText",
  componentId: "sc-e47npl-5"
})(["color:", ";font-size:16px;margin:15px 0;text-transform:uppercase;"], _palette.commonPalette.white);
var StyledSpinner = exports.StyledSpinner = (0, _styledComponents["default"])(_Spinner["default"]).withConfig({
  displayName: "styles__StyledSpinner",
  componentId: "sc-e47npl-6"
})(["position:relative;margin-left:20px;margin-bottom:30px;"]);
var StyledText = exports.StyledText = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledText",
  componentId: "sc-e47npl-7"
})(["padding:0 0 15px 15px;color:", ";", ""], _palette.commonPalette.txLightGrey, function (_ref4) {
  var isDesktop = _ref4.isDesktop;
  return isDesktop ? 'margin: 15px 0 0 15px;' : '';
});
var StyledWrapper = exports.StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledWrapper",
  componentId: "sc-e47npl-8"
})(["display:flex;", " gap:16px;flex:1;z-index:10;position:relative;"], function (_ref5) {
  var isDesktop = _ref5.isDesktop,
    showSignature = _ref5.showSignature;
  return showSignature || !showSignature && !isDesktop ? 'flex-direction: column;' : '';
});
var ClickBlocker = exports.ClickBlocker = _styledComponents["default"].div.withConfig({
  displayName: "styles__ClickBlocker",
  componentId: "sc-e47npl-9"
})(["position:absolute;top:0;bottom:0;right:0;left:0;width:100%;height:100%;z-index:5;"]);
//# sourceMappingURL=styles.js.map